export enum ActionTypes {
  GET_USER_PROJECTS_REQUEST = 'projects/GET_USER_PROJECTS_REQUEST',
  GET_USER_PROJECTS_SUCCESS = 'projects/GET_USER_PROJECTS_SUCCESS',
  GET_USER_PROJECTS_ERROR = 'projects/GET_USER_PROJECTS_ERROR',
  GET_ARCHIVED_PROJECTS_REQUEST = 'projects/GET_ARCHIVED_PROJECTS_REQUEST',
  GET_ARCHIVED_PROJECTS_SUCCESS = 'projects/GET_ARCHIVED_PROJECTS_SUCCESS',
  GET_ARCHIVED_PROJECTS_ERROR = 'projects/GET_ARCHIVED_PROJECTS_ERROR',
  POST_PROJECT_SUCCESS = 'projects/POST_PROJECT_SUCCESS',
  POST_PROJECT_ERROR = 'projects/POST_PROJECT_ERROR',
  EDIT_PROJECT_SUCCESS = 'projects/EDIT_PROJECT_SUCCESS',
  EDIT_PROJECT_ERROR = 'projects/EDIT_PROJECT_ERROR',
  DELETE_PROJECT_SUCCESS = 'project/DELETE_PROJECT_SUCCESS',
  DELETE_PROJECT_ERROR = 'project/DELETE_PROJECT_ERROR',
  RESTORE_ARCHIVED_PROJECT_SUCCESS = 'projects/RESTORE_ARCHIVED_PROJECT_SUCCESS',
  RESTORE_ARCHIVED_PROJECT_ERROR = 'projects/RESTORE_ARCHIVED_PROJECT_ERROR',
  SET_SHOW_INFO = 'edit/SET_SHOW_INFO',
  SET_EDIT = 'edit/SET_EDIT',
  EDIT_PAGE_SUCCESS = 'edit/EDIT_PAGE_SUCCESS',
  ADD_PAGE_SUCCESS = 'edit/ADD_PAGE_SUCCESS',
  DELETE_PAGE_SUCCESS = 'edit/DELETE_PAGE_SUCCESS',
  ADD_FOLDER_SUCCESS = 'edit/ADD_FOLDER_SUCCESS',
  UPDATE_FOLDER_SUCCESS = 'edit/UPDATE_FOLDER_SUCCESS',
  GET_FOLDER_SUCCESS = 'edit/GET_FOLDER_SUCCESS',
  DELETE_FOLDER_ERROR = 'edit/DELETE_FOLDER_ERROR',
  CLOSE_ERROR_MESSAGE = 'CLOSE_ERROR_MESSAGE',
  SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE',
  DELETE_FOLDER_SUCCESS = 'DELETE_FOLDER_SUCCESS',
  DELETE_ARCHIVED_PROJECT_SUCCESS = 'DELETE_ARCHIVED_PROJECT_SUCCESS',
  SET_SUCCESS_MESSAGE = 'SET_SUCCESS_MESSAGE',
  CLOSE_SUCCESS_MESSAGE = 'CLOSE_SUCCESS_MESSAGE',
  SET_PROPOSALS = 'SET_PROPOSALS',
  DELETE_PROPOSAL_SUCCESS = 'DELETE_PROPOSAL_SUCCESS',
  SET_PAGE_DETAILS = 'SET_PAGE_DETAILS',
  GET_SUBSCRIPTION_SUCCESS = 'GET_SUBSCRIPTION_SUCCESS',
  SET_PRO_FEATURE_ERROR = 'SET_PRO_FEATURE_ERROR',
  CLEAR_PRO_FEATURE_ERROR = 'CLEAR_PRO_FEATURE_ERROR',
  GET_DRAWING_SETS_SUCCESS = 'projects/GET_DRAWING_SETS_SUCCESS',
  ADD_DRAWING_SET_SUCCESS = 'projects/ADD_DRAWING_SET_SUCCESS',
  UPDATE_DRAWING_SET_SUCCESS = 'projects/UPDATE_DRAWING_SET_SUCCESS',
  DELETE_DRAWING_SET_SUCCESS = 'projects/DELETE_DRAWING_SET_SUCCESS',
  SET_ACTIVE_DRAWING_SET_SUCCESS = 'projects/SET_ACTIVE_DRAWING_SET_SUCCESS',
  PAGE_METADATA_SUCCESS = 'projects/PAGE_METADATA_SUCCESS',
  PAGES_ADDED_SUCCESS = 'projects/PAGES_ADDED_SUCCESS',
}
